import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import { useSelector } from "react-redux";
import {
    selectTimerStatus
} from "../../sessionWatchSlice"; // import the stylesheet
import { TIMER_STATUS } from "../../constants";
import { SESSION_TRACKER_BACKGROUND_COLOR } from "../../../../../buckets/constants";
import { PastNotes } from "../pastNotes/PastNotes";
import { SessionAnalysis } from "../sessionAnalysis/SessionAnalysis";

export const Dashboard = () => {
    const timerStatus = useSelector(selectTimerStatus);
    const [strategies, setStrategies] = useState("");

    useEffect(() => {
        const strategiesRaw = JSON.parse(localStorage.getItem("strategies")) || "";
        setStrategies(strategiesRaw);
    }, [timerStatus]);

    return timerStatus === TIMER_STATUS[0] && (
        <div style={{ backgroundColor: SESSION_TRACKER_BACKGROUND_COLOR }} className="dashboard-container">
            {/* Session Analysis Section - Only show when timer is NOT running */}
            {<SessionAnalysis />}

            <div className="dashboard-content-row">
                {<PastNotes />}

                {/* Strategies Section - Only show when timer is NOT running */}
                {strategies && (
                    <div className="dashboard-section" id="dashboardStrategies">
                        <h2 className="dashboard-heading">🧠 Strategies</h2>
                        <div className="dashboard-section-content">
                            <div className="strategies-display">
                                {strategies.split('\n').map((line, index) => (
                                    <div key={index} className="strategy-item">
                                        {line}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};